module.exports = __webpack_public_path__ + "static/cam-aleon-3282be67e130d12db7ef59ce268751e0.webm";